import utils from '@bigcommerce/stencil-utils';
import 'foundation-sites/js/foundation/foundation';
import 'foundation-sites/js/foundation/foundation.reveal';
import ImageGallery from '../product/image-gallery';
import modalFactory, { showAlertModal } from '../global/modal';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isPlainObject from 'lodash/isPlainObject';
import Wishlist from '../wishlist';
import swal from '../global/sweet-alert';
import bannerUtils from './utils/banner-utils';
import openSlideCart from './open-slide-cart';
import { debounce } from './utils/debounce';
import { bus, Events } from './event-bus';
import {
    buildBackorderContext,
    mergeBackorderData,
    backorderedQty,
    sellLimitExceeded,
    resolveBackorderMessage,
    canSell,
    showAvailabilityPrompt,
    mergeLiveInventory,
} from './utils/backorder-utils';
import { fetchLiveInventory } from './utils/live-inventory';
//import productGallery from '../custom/product/product-gallery';


function addDaysToDateString(dateStr, days) {
    const n = parseInt(days, 10);
    if (!n || !dateStr) return dateStr;
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    date.setDate(date.getDate() + n);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export default class ProductDetails {
    /**
     * @param hooks Store-specific behavior bundle injected by the construction
     * site (product.js and global/quick-view.js) — see buildPdpHooks() in
     * custom/product/pdp-hooks.js. Every hook call is optional-chained: with
     * no hooks the class runs standalone with base behavior only.
     */
    constructor($scope, context, productAttributesData = {}, hooks = {}) {
        this.$overlay = $('[data-cart-item-add] .loadingOverlay');
        this.$scope = $scope;
        this.context = context;
        this.hooks = hooks;
        // Backorder display context (see utils/backorder-utils.js). Inert when the
        // stock.html injects are absent (quick view) or the store has backorders off.
        this.backorder = buildBackorderContext(this.context);
        this.imageGallery = new ImageGallery($('[data-image-gallery]', this.$scope));
        this.imageGallery.init();
        this.listenQuantityChange();
        this.initRadioAttributes();
        this.$slick = $('#product-details-image-carousel');

        // Drop the server-rendered first-paint pre-hide markers BEFORE slick
        // initializes, so slick never measures a `display: none` slide (it would
        // read 0x0 and mis-size the track). product-view.html stamps
        // .is-gallery-prehidden onto the thumbnails whose "|| Option Value" token
        // doesn't match the preselected option, and custom/pages/_product.scss
        // hides them, which is what keeps the unfiltered set off first paint -
        // the server streams every <li> ~200ms before this file runs, so no
        // JS-only filter can win that race. Everything from here through the
        // optionImageGallery hook call below runs in a single JavaScript task,
        // so no intermediate paint happens and the shopper never sees the
        // unfiltered strip. Kept as a plain class-name string rather than an
        // import: common/ must not depend on custom/.
        this.$slick.children('.is-gallery-prehidden').removeClass('is-gallery-prehidden');

        if (!this.$slick.hasClass('slick-initialized')) {
            this.$slick.slick({
                infinite: false,
                mobileFirst: true,
                slidesToShow: 4,
                slidesToScroll: 2,
                dots: false,
                useTransform: true,
                swipe: true,
                draggable: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 550,
                        settings: { slidesToShow: 5 }
                    },
                    {
                        breakpoint: 800,
                        settings: { slidesToShow: 6 }
                    },
                    {
                        breakpoint: 1260,
                        settings: {
                            slidesToShow: 6,
                            vertical: true,
                            verticalSwiping: true,
                            adaptiveHeight: true,
                            // `variableWidth` MUST be off wherever `vertical` is
                            // on: slick computes the vertical offset and then
                            // unconditionally overwrites it in its variableWidth
                            // branch (slick.js:1134-1157) with
                            // `targetSlide.offsetLeft * -1`. In a vertical strip
                            // every slide is stacked, so offsetLeft is ~0 for all
                            // of them, targetLeft is always 0, and setCSS writes
                            // translate3d(0,0,0) forever - the arrows update
                            // currentSlide and their own disabled state while the
                            // track never moves. Measured on an 11-thumbnail
                            // product: 6 slides in the window, 5 unreachable, three
                            // next-clicks with zero movement. The horizontal
                            // breakpoints keep variableWidth, where offsetLeft is
                            // the correct axis and it works as intended.
                            variableWidth: false
                        }
                    }
                ]
            });
        }

        // Run the gallery filter synchronously, in the same task as slick init
        // and before first paint - see updateProductAttributes() below for the
        // ajax-driven re-filter on later option changes. The server renders the
        // default option as `checked` (product-view.html's option partials), so
        // readSelectedLabels() already returns the right label with no network
        // round trip; passing {} for `data` is safe because hasSelection() only
        // needs the label, not an attributes payload. This eliminates the
        // unfiltered-then-filtered flash a shopper would otherwise see between
        // slick's initial render (all thumbnails) and the first ajax response.
        this.hooks.optionImageGallery?.({}, this.$scope, this.$slick);

        //productGallery();
        //$main.slick('unslick');
        //$nav.slick('unslick');

        //this.onPersonalizeButtonAppears();
        Wishlist.load(this.context);
        this.getTabRequests();

        const $form = $('form[data-cart-item-add]', $scope);
        const $productOptionsElement = $('[data-product-option-change]', $form);
        const hasOptions = $productOptionsElement.html().trim().length;
        const hasDefaultOptions = $productOptionsElement.find('[data-default]').length;
        const $buyNowBtn = $('#buy-now-button-main');
        const $atcBtn = $('#form-action-addToCart');

        $productOptionsElement.on('change', event => {
            //this.productOptionsChanged(event);
            this.debounceproductOptionsChanged(event);
            this.setProductVariant();
        });

        $atcBtn.on('click', event => {
            if (!$form[0].checkValidity()) {
                $form[0].reportValidity();
            } else {
                this.addProductToCart(event, $form[0]);
            }
        });

        $buyNowBtn.on('click', event => {
            if (!$form[0].checkValidity()) {
                $form[0].reportValidity();
            } else {
                this.buyNowButton(event);
            }
        });


        if (!this._artifiListenerAttached) {
            document.addEventListener('artifi-customize-button-inserted', () => {
                this.onPersonalizeButtonAppears();
            });
            this._artifiListenerAttached = true;
        }


        // Update product attributes. Also update the initial view in case items are oos
        // or have default variant properties that change the view
        if ((isEmpty(productAttributesData) || hasDefaultOptions) && hasOptions) {
            const $productId = $('[name="product_id"]', $form).val();

            utils.api.productAttributes.optionChange($productId, $form.serialize(), 'products/bulk-discount-rates', (err, response) => {
                if (this.context.themeSettings.show_OVR_Shipping) {
                    this.hooks.detailsOvrPricing?.(this.context.productSku, this.context.onlineServicesHost);
                }

                //console.debug("getDetailsOvrPricing: ",  happens);
                const attributesData = response?.data || {};
                const attributesContent = response?.content || {};
                //console.log(attributesData);

                //Make A Call To Get Sku Inventory
                var rself = this;
                //CUSTOM UPDATED: Custom Logic
                if (attributesData != null && Object.keys(attributesData).length > 0) {


                    //console.log(attributesData.sku);
                    this.getLiveInventoryInfo(attributesData.sku, function (inventoryInfo) {

                        let tempSku = attributesData.sku;
                        if (tempSku?.endsWith('BC')) {
                            tempSku = tempSku.slice(0, -2);
                        }




                            // try {
                            //     //debouncedProductDetailsChange(tempSku, rself.context.themeSettings.shopper_approved_siteId, rself.context.productSku.price.without_tax.value, rself.context.productSku.id, rself.context.onlineServicesHost, rself.context.themeSettings.appId, null, rself.context.productSku.custom_fields);
                            //     //createSubscriptionWidget('add-to-cart-wrapper-custom', 'attribute_select_1558');
                            // }
                            // catch (error) {
                            //     console.log("Product Details Change Error:");
                            //     console.log(error);
                            // }

                        try {
                            rself.hooks.variantDetailsChange?.(tempSku, rself.context.themeSettings.shopper_approved_siteId, rself.context.productSku.price.without_tax.value, rself.context.productSku.id, rself.context.onlineServicesHost, rself.context.themeSettings.appId, null, rself.context.productSku.custom_fields, rself.context.themeSettings.shopper_approved_review_widgetId, rself.context.gqlProduct?.metafields?.edges,null, rself.context.themeSettings.subscription_modifier_label_discount);
                            rself.hooks.configuratorPriceUpdate?.(tempSku, rself.context.authorization, productAttributesData?.image?.data,rself.context.gqlProduct?.metafields?.edges);

                            //configuratorVariantPriceUpdate(tempSku,rself.context.authorization);                        
                            //createSubscriptionWidget('add-to-cart-wrapper-custom', 'attribute_select_1558');
                        }
                        catch (error) {
                            console.log("Product Details Change Error:");
                            console.log(error);
                        }


                        //console.log("ARe hwer ehere 1");
                        //console.log(inventoryInfo);

                        if (inventoryInfo.nextAvailableDateDisplay != null && inventoryInfo.avaliableQuantity < 2) {
                            const _displayDate = addDaysToDateString(
                                inventoryInfo.nextAvailableDateDisplay,
                                rself.context.themeSettings.availability_date_offset_days
                            );
                            const stockMsg = "Available for purchase but will not ship until " + _displayDate;
                            attributesData.stock_message = stockMsg;
                            rself.showMessageBox(stockMsg);
                        }


                        if (inventoryInfo.isDoNotReorder ==  true && inventoryInfo.avaliableQuantity > 0) {
                            let inStockMessage = document.getElementsByClassName("card-stock card-stock--inStock")[0];
                            if (inStockMessage != null) {
                                //inStockMessage.innerText = "Currently in stock but discontinued";
                            }
                        }

                      

                    });
                }



                this.updateProductAttributes(attributesData);
                if (hasDefaultOptions) {
                    this.updateView(attributesData, attributesContent);
                } else {
                    mergeBackorderData(this.backorder, attributesData);
                    this.updateDefaultAttributesForOOS(attributesData);
                    this.refreshBackorderView();
                }
            });
        } else {
            this.updateProductAttributes(productAttributesData);
            bannerUtils.dispatchProductBannerEvent(productAttributesData);
            // Backorder: draw the row for the default quantity now. available_for_backorder and
            // backorder_message_id only exist in the option-change response, so fetch once - but
            // only when the store explicitly shows backorders, to avoid an extra request elsewhere.
            this.refreshBackorderView();
            if (this.backorder.hasDisplayFlag) {
                const backorderProductId = $('[name="product_id"]', $form).val();
                utils.api.productAttributes.optionChange(backorderProductId, $form.serialize(), (err, response) => {
                    if (err || !response || !response.data) return;
                    mergeBackorderData(this.backorder, response.data);
                    this.updateDefaultAttributesForOOS(response.data);
                    this.refreshBackorderView();
                });
            }
            if (this.context.themeSettings.show_OVR_Shipping) {
                this.hooks.detailsOvrPricing?.(productAttributesData, this.context.onlineServicesHost);
            }

            //console.debug("getOvrPricing: ",  happens);
            //console.log("Product With No OPtions");
            //console.log(productAttributesData);

            const _availDateOffset = this.context.themeSettings.availability_date_offset_days;
            if (productAttributesData != null && productAttributesData.sku != null) {
                var rself = this;
                this.getLiveInventoryInfo(productAttributesData.sku, function (inventoryInfo) {
                    console.log(inventoryInfo);

                    if (inventoryInfo.nextAvailableDateDisplay != null && inventoryInfo.avaliableQuantity < 2) {
                        const _displayDate = addDaysToDateString(inventoryInfo.nextAvailableDateDisplay, _availDateOffset);
                        const stockMsg = "Available for purchase but will not ship until " + _displayDate;
                        productAttributesData.stock_message = stockMsg;
                        rself.showMessageBox(stockMsg);
                    }

                    if (inventoryInfo.isDoNotReorder ==  true && inventoryInfo.avaliableQuantity > 0) {
                        let inStockMessage = document.getElementsByClassName("card-stock card-stock--inStock")[0];
                         if (inStockMessage != null) {
                            //inStockMessage.innerText = "Currently in stock but discontinued";
                        }
                    }


                });

                this.hooks.variantDetailsChange?.(productAttributesData.sku, this.context.themeSettings.shopper_approved_siteId, this.context.productSku.price.without_tax.value, this.context.productSku.id, this.context.onlineServicesHost, this.context.themeSettings.appId, null, this.context.productSku.custom_fields, this.context.themeSettings.shopper_approved_review_widgetId,this.context.gqlProduct?.metafields?.edges,null,this.context.themeSettings.subscription_modifier_label_discount);
                this.hooks.configuratorPriceUpdate?.(productAttributesData.sku, this.context.authorization, productAttributesData?.image?.data,this.context.gqlProduct?.metafields?.edges);

                //configuratorVariantPriceUpdate(productAttributesData.sku,this.context.authorization);
                //createSubscriptionWidget('add-to-cart-wrapper-custom', 'attribute_select_1558');
            }
        }

        $productOptionsElement.show();

        this.previewModal = modalFactory('#previewModal')[0];
        this.quickviewModal = modalFactory('#modal')[0];
        this.messageBoxTimer = setTimeout(() => { }, 0);
        this.recommendedAccessories();
    }

    /**
     * https://stackoverflow.com/questions/49672992/ajax-request-fails-when-sending-formdata-including-empty-file-input-in-safari
     * Safari browser with jquery 3.3.1 has an issue uploading empty file parameters. This function removes any empty files from the form params
     * @param formData: FormData object
     * @returns FormData object
     */
    filterEmptyFilesFromForm(formData) {
        try {
            for (const [key, val] of formData) {
                if (val instanceof File && !val.name && !val.size) {
                    formData.delete(key);
                }
            }
        } catch (e) {
            console.error(e); // eslint-disable-line no-console
        }
        return formData;
    }

    setProductVariant() {
        const unsatisfiedRequiredFields = [];
        const options = [];

        $.each($('[data-product-attribute]'), (index, value) => {
            //console.debug("index : ",index);
            //console.debug("value : ",value);
            const optionLabel = value.children[0].innerText;
            const optionTitle = optionLabel.split(':')[0].trim();
            const required = optionLabel.toLowerCase().includes('required');
            const type = value.getAttribute('data-product-attribute');

            if ((type === 'input-file' || type === 'input-text' || type === 'input-number') && value.querySelector('input').value === '' && required) {
                unsatisfiedRequiredFields.push(value);
            }

            if (type === 'textarea' && value.querySelector('textarea').value === '' && required) {
                unsatisfiedRequiredFields.push(value);
            }

            if (type === 'date') {
                const isSatisfied = Array.from(value.querySelectorAll('select')).every((select) => select.selectedIndex !== 0);

                if (isSatisfied) {
                    const dateString = Array.from(value.querySelectorAll('select')).map((x) => x.value).join('-');
                    options.push(`${optionTitle}:${dateString}`);

                    return;
                }

                if (required) {
                    unsatisfiedRequiredFields.push(value);
                }
            }

            if (type === 'set-select') {
                const select = value.querySelector('select');
                const selectedIndex = select.selectedIndex;

                if (selectedIndex !== 0) {
                    options.push(`${optionTitle}:${select.options[selectedIndex].innerText}`);

                    return;
                }

                if (required) {
                    unsatisfiedRequiredFields.push(value);
                }
            }

            if (type === 'set-rectangle' || type === 'set-radio' || type === 'swatch' || type === 'input-checkbox' || type === 'product-list') {
                const checked = value.querySelector(':checked');
                if (checked) {
                    if (type === 'set-rectangle' || type === 'set-radio' || type === 'product-list') {
                        const label = checked.labels[0].innerText;
                        if (label) {
                            options.push(`${optionTitle}:${label}`);
                        }
                    }

                    if (type === 'swatch') {
                        const label = checked.labels[0].children[0];
                        if (label) {
                            options.push(`${optionTitle}:${label.title}`);
                        }
                    }

                    if (type === 'input-checkbox') {
                        options.push(`${optionTitle}:Yes`);
                    }

                    return;
                }

                if (type === 'input-checkbox') {
                    options.push(`${optionTitle}:No`);
                }

                if (required) {
                    unsatisfiedRequiredFields.push(value);
                }
            }
        });

        let productVariant = unsatisfiedRequiredFields.length === 0 ? options.sort().join(', ') : 'unsatisfied';
        const view = $('.productView');

        if (productVariant) {
            productVariant = productVariant === 'unsatisfied' ? '' : productVariant;
            if (view.attr('data-event-type')) {
                view.attr('data-product-variant', productVariant);
            } else {
                const productName = view.find('.productView-title')[0].innerText;
                // Hotfix to stop js breaking on products with quotation marks in their name
                const sanitisedName = productName.replace(/(['"])/g, "\\$1"); // eslint-disable-line quotes
                // Unsupported still, maybe later
                // let sanitisedName = CSS.escape(productName);
                const card = $(`[data-name='${sanitisedName}']`);
                card.attr('data-product-variant', productVariant);

                // Old code
                // const productName = view.find('.productView-title')[0].innerText;
                // const card = $(`[data-name="${productName}"]`);
                // card.attr('data-product-variant', productVariant);
            }
        }
    }

    /**
     * Since $productView can be dynamically inserted using render_with,
     * We have to retrieve the respective elements
     *
     * @param $scope
     */
    getViewModel($scope) {
        return {
            $priceWithTax: $('[data-product-price-with-tax]', $scope),
            $priceWithoutTax: $('[data-product-price-without-tax]', $scope),
            rrpWithTax: {
                $div: $('.rrp-price--withTax', $scope),
                $span: $('[data-product-rrp-with-tax]', $scope),
            },
            rrpWithoutTax: {
                $div: $('.rrp-price--withoutTax', $scope),
                $span: $('[data-product-rrp-price-without-tax]', $scope),
            },
            nonSaleWithTax: {
                $div: $('.non-sale-price--withTax', $scope),
                $span: $('[data-product-non-sale-price-with-tax]', $scope),
            },
            nonSaleWithoutTax: {
                $div: $('.non-sale-price--withoutTax', $scope),
                $span: $('[data-product-non-sale-price-without-tax]', $scope),
            },
            priceSaved: {
                $div: $('.price-section--saving', $scope),
                $span: $('[data-product-price-saved]', $scope),
            },
            priceNowLabel: {
                $span: $('.price-now-label', $scope),
            },
            priceLabel: {
                $span: $('.price-label', $scope),
            },
            $weight: $('.productView-info [data-product-weight]', $scope),
            $increments: $('.form-field--increments :input', $scope),
            $addToCart: $('#form-action-addToCart', $scope),
            $wishlistVariation: $('[data-wishlist-add] [name="variation_id"]', $scope),
            stock: {
                $container: $('.productView__stock', $scope),
                $input: $('[data-product-stock]', $scope),
            },
            sku: {
                $label: $('dt.sku-label', $scope),
                $value: $('[data-product-sku]', $scope),
            },
            upc: {
                $label: $('dt.upc-label', $scope),
                $value: $('[data-product-upc]', $scope),
            },
            quantity: {
                $text: $('.incrementTotal', $scope),
                $input: $('[name=qty\\[\\]]', $scope),
            },
            $bulkPricing: $('.productView-info-bulkPricing', $scope),
        };
    }

    /**
     * Checks if the current window is being run inside an iframe
     * @returns {boolean}
     */
    isRunningInIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    /**
     *
     * Handle product options changes
     *
     */
    


    productOptionsChanged(event) {
        const $changedOption = $(event.target);
        const $form = $changedOption.parents('form');
        const productId = $('[name="product_id"]', $form).val();

        // Do not trigger an ajax request if it's a file or if the browser doesn't support FormData
        if ($changedOption.attr('type') === 'file' || window.FormData === undefined) {
            return;
        }


        utils.api.productAttributes.optionChange(productId, $form.serialize(), 'products/bulk-discount-rates', (err, response) => {
            const productAttributesData = response?.data || {};
            const productAttributesContent = response?.content || {};
            if (productAttributesData != null) {
                if (this.context.themeSettings.show_OVR_Shipping) {
                    this.hooks.detailsOvrPricing?.(productAttributesData, this.context.onlineServicesHost);
                }


                var rself = this;

                this.getLiveInventoryInfo(productAttributesData.sku, function (inventoryInfo) {
                    if (inventoryInfo.nextAvailableDateDisplay != null && inventoryInfo.avaliableQuantity < 2) {
                        const _displayDate = addDaysToDateString(
                            inventoryInfo.nextAvailableDateDisplay,
                            rself.context.themeSettings.availability_date_offset_days
                        );
                        const stockMsg = "Available for purchase but will not ship until " + _displayDate;
                        productAttributesData.stock_message = stockMsg;
                        rself.showMessageBox(stockMsg);
                    }
                });


                this.updateProductAttributes(productAttributesData);
                this.updateView(productAttributesData, productAttributesContent);

                bannerUtils.dispatchProductBannerEvent(productAttributesData);
            }

            //console.debug("productAttributesData : ",productAttributesData);
            //console.log(productAttributesData);

        });
    }
    debounceproductOptionsChanged = debounce(this.productOptionsChanged, 200, 'productOptionsChanged'); 
    showProductImage(image) {
        if (isPlainObject(image)) {

            const zoomImageUrl = utils.tools.imageSrcset.getSrcset(
                image.data,
                { '1x': this.context.themeSettings.zoom_size },
                /*
                    Should match zoom size used for data-zoom-image in
                    components/products/product-view.html
                    Note that this will only be used as a fallback image for browsers that do not support srcset
                    Also note that getSrcset returns a simple src string when exactly one size is provided
                */
            );

            const mainImageUrl = utils.tools.imageSrcset.getSrcset(
                image.data,
                { '1x': this.context.themeSettings.product_size },
                /*
                    Should match fallback image size used for the main product image in
                    components/products/product-view.html
                    Note that this will only be used as a fallback image for browsers that do not support srcset
                    Also note that getSrcset returns a simple src string when exactly one size is provided
                */
            );

            const mainImageSrcset = utils.tools.imageSrcset.getSrcset(image.data);

            this.imageGallery.setAlternateImage({
                mainImageUrl,
                zoomImageUrl,
                mainImageSrcset,
            });
        } else {
            this.imageGallery.restoreImage();
        }
    }

    /**
     *
     * Handle action when the shopper clicks on + / - for quantity
     *
     */
    listenQuantityChange() {
        this.$scope.on('click', '[data-quantity-change] button', event => {
            event.preventDefault();
            const $target = $(event.currentTarget);
            const viewModel = this.getViewModel(this.$scope);
            const $input = viewModel.quantity.$input;
            const quantityMin = parseInt($input.data('quantity-min'), 10);
            const quantityMax = parseInt($input.data('quantity-max'), 10);

            let qty = parseInt($input.val(), 10);

            // If action is incrementing
            if ($target.data('action') === 'inc') {
                // If quantity max option is set
                if (quantityMax > 0) {
                    // Check quantity does not exceed max
                    if ((qty + 1) <= quantityMax) {
                        qty++;
                    }
                } else {
                    qty++;
                }
            } else if (qty > 1) {
                // If quantity min option is set
                if (quantityMin > 0) {
                    // Check quantity does not fall below min
                    if ((qty - 1) >= quantityMin) {
                        qty--;
                    }
                } else {
                    qty--;
                }
            }

            // update hidden input
            viewModel.quantity.$input.val(qty);
            // update text
            viewModel.quantity.$text.text(qty);
            this.refreshBackorderView(qty);
        });

        // Typed quantities: keep the backorder row and the sell-limit gate in sync.
        this.$scope.on('keyup', '.form-input--incrementTotal', () => {
            const $input = this.getViewModel(this.$scope).quantity.$input;
            this.refreshBackorderView(parseInt($input.val(), 10) || 0);
        });
    }

    buyNowButton(event) {
        event.preventDefault();
        const $atcAction = $('#atc-form-action');
        const $form = $('form[data-cart-item-add]');

        $atcAction.val('buy');

        $form.submit();
    }
    onPersonalizeButtonAppears() {
        console.log('Artifi button is ready. Initializing custom UI for SKU:', productSku);

        const addToCartWrapper = document.getElementById('add-to-cart-wrapper');
        if (!addToCartWrapper || addToCartWrapper.style.display === "none") {
            console.log('Add to cart wrapper not visible, aborting designer launch.');
            return; // Exit if the add to cart wrapper isn't visible
        }

        // Hide original BigCommerce elements
        document.getElementById('productView-images-container')?.setAttribute('style', 'display: none;');
        document.querySelector('.productView-info')?.setAttribute('style', 'display: none;');
        document.getElementById('productView-details-price-header')?.setAttribute('style', 'display: none;');
        document.getElementById('data-product-option-change-form')?.setAttribute('style', 'display: none;');

        // Ensure the main section is visible and class is updated
        document.getElementById('product-view-section')?.setAttribute('style', 'display: block;');
        const productViewContainer = document.getElementById('product-view-inner-container');
        if (productViewContainer) {
            productViewContainer.classList.remove('productView-inner');
            productViewContainer.classList.add('productView-inner-custom-products');
            //productViewContainer.style.display = 'grid';
            // productViewContainer.style.gridTemplateColumns = '5fr 1fr';
            // productViewContainer.style.gridTemplateRows = '1fr';
            // productViewContainer.style.gridColumnGap = '0px';
            // productViewContainer.style.gridRowGap = '0xp';
        }
        //document.querySelector("#artifi-personalize-button-container > div")?.setAttribute('style', 'display: none;');    

        const bigCommerceProductView = document.getElementById('bigCommerceProductView');
        if (bigCommerceProductView) {
            bigCommerceProductView.classList.add('productView-inner-custom-products-top');
            //bigCommerceProductView.setAttribute('style','grid-area: 1 / 1 / 2 / 2;');
        }

        const buySection = document.querySelector('.buy-section');
        if (buySection) {
            buySection.classList.add('productView-inner-custom-products-bottom');
            //buySection.setAttribute('style','grid-area: 1 / 2 / 2 / 3;');
        }

        // Initially build the custom product view with the current SKU
        this.hooks.configuratorPriceUpdate?.(productSku, this.context.authorization,this.context.gqlProduct?.metafields?.edges);
        //configuratorVariantPriceUpdate(productSku,this.context.authorization);

        // Launch the Artifi designer iframe
        if (window.BigCommerceArtifi && typeof window.BigCommerceArtifi.ProductPage.launchDesignerForVariant === 'function') {
            BigCommerceArtifi.ProductPage.launchDesignerForVariant(productSku, '');
            const artifiCloseButton = document.getElementById("bigcommerce-artifi-popup-header-close-button");
            if (artifiCloseButton) {
                artifiCloseButton.style.display = 'none';
            }

        } else {
            console.error('BigCommerceArtifi object or launchDesignerForVariant function not found.');
        }

    }
    /**
     *
     * Add a product to cart
     *
     */

    addProductToCart(event, form) {
        const $addToCartBtn = $('#form-action-addToCart', $(event.target));
        const originalCart = form.querySelector('#form-action-addToCart');

        if(originalCart != null){
            const customProduct = originalCart.getAttribute('add-to-cart-custom');
            if(customProduct === 'true'){
                //triggerAddToCartEventArtifi();
                return;
            }
        }
        const productSkuBc = document.querySelector("#gql_product_variants")?.dataset?.productSku;

        const originalBtnVal = $addToCartBtn.val();
        const waitMessage = $addToCartBtn.data('waitMessage');

        const qtyInput = $(event.target).closest('.form').find('.form-input--incrementTotal') || 1;
        const qtyMin = parseInt(qtyInput.attr('data-quantity-min'), 10) || null;
        const qtyMax = parseInt(qtyInput.attr('data-quantity-max'), 10) || null;
        const minErr = qtyInput.attr('data-quantity-min-error') || null;
        const maxErr = qtyInput.attr('data-quantity-max-error') || null;
        const newQty = parseInt(Number(qtyInput.val()), 10) || 0;

        const $atcAction = $('#atc-form-action');
        $atcAction.val('add');

        // Do not do AJAX if browser doesn't support FormData
        if (window.FormData === undefined) {
            return;
        }

        // Prevent default
        event.preventDefault();
        //console.log("addProductToCart details",form);
        const skuDataElement = form.querySelector('input[type="hidden"][name="product_id"]');
        // if(skuDataElement){
        //     const skuData = skuDataElement.value;
        //     const qtyDataElement = form.querySelector('input[id="qty[]"][name="qty[]"]');
        //     let qtyData = 1;
        //     if(qtyDataElement){
        //         qtyData  = qtyDataElement.value;
        //     }
        //     console.log("qtyInput: ", qtyInput);
        //     getAddToCartData(skuData,qtyData);
        // }

        $addToCartBtn
            .val(waitMessage)
            .prop('disabled', true);

        // Does not quality for min/max quantity
        if (newQty < qtyMin) {
            $addToCartBtn
                .val(originalBtnVal)
                .prop('disabled', false);

            this.showMessageBox(minErr, 4000);
            // swal({
            //     text: minErr,
            //     type: 'error',
            // }).catch(swal.noop);
        } else if (qtyMax > 0 && newQty > qtyMax) {
            $addToCartBtn
                .val(originalBtnVal)
                .prop('disabled', false);

            this.showMessageBox(maxErr, 4000);
            // swal({
            //     text: maxErr,
            //     type: 'error',
            // }).catch(swal.noop);
        } else if (sellLimitExceeded(this.backorder, newQty) !== null) {
            // Backorder sell limit (available_to_sell) - a typed quantity can reach
            // submit before the keyup gate runs.
            $addToCartBtn
                .val(originalBtnVal)
                .prop('disabled', false);

            this.showMessageBox(
                this.backorder.maxMessage.replace('__QTY__', sellLimitExceeded(this.backorder, newQty)),
                4000,
            );
        } else if (newQty < 0 || Number.isNaN(newQty)) {
            $addToCartBtn
                .val(originalBtnVal)
                .prop('disabled', false);

            const invalidEntry = qtyInput.val();
            qtyInput.val(qtyMin);

            this.showMessageBox(`${invalidEntry} is not a valid entry`, 4000);
            // swal({
            //     text: `${invalidEntry} is not a valid entry`,
            //     type: 'error',
            // })
            //     .catch(swal.noop);
        } else {
            this.$overlay.show();

            // Add item to cart
            utils.api.cart.itemAdd(this.filterEmptyFilesFromForm(new FormData(form)), (err, response) => {
                const errorMessage = err || response.data.error;

                this.$overlay.hide();

                $addToCartBtn
                    .val(originalBtnVal)
                    .prop('disabled', false);

                // Guard statement
                if (errorMessage) {
                    // Strip the HTML from the error message
                    const tmp = document.createElement('DIV');
                    tmp.innerHTML = errorMessage;

                    return showAlertModal(tmp.textContent || tmp.innerText);
                }

                if (this.quickviewModal) {
                    this.quickviewModal.close();
                }

                // Open preview modal and update content
                // ******* CHANGED FROM POPUP MODAL TO SLIDEOUT CART - 6.14.24 WTK ***********
                // if (this.previewModal) {
                //     if (this.context.addToCartMode === 'popup') {
                //         this.previewModal.open();
                //     }

                //     this.updateCartContent(this.previewModal, response.data.cart_item.id);
                // } else {
                //     this.$overlay.show();
                //     // if no modal, redirect to the cart page
                //     this.redirectTo(response.data.cart_item.cart_url || this.context.urls.cart);
                // }

                getAddToCartData(response);

                // GA4 add_to_cart — enrich cart_item with product context and
                // line_items data since itemAdd API response omits many fields
                const product = this.context.product;
                const cartData = response.data;
                // Match the line item for this product (first match by product_id)
                const lineItem = (cartData.line_items || [])
                    .find(li => li.product_id === cartData.cart_item?.product_id)
                    || cartData.line_items?.[0]
                    || {};
                // Fall back to DOM title if context product is unavailable
                const productName = product?.title || product?.name
                    || document.querySelector('h1.productView-title, .productView-title')?.textContent?.trim()
                    || '';
                const productSku  = productSkuBc ||product?.sku || '';
                const enrichedCartItem = {
                    ...cartData.cart_item,
                    name:           lineItem.product_name || cartData.cart_item.name || productName,
                    product_sku:    productSku || lineItem.sku || cartData.cart_item.sku,
                    variant_sku:    lineItem.sku || cartData.cart_item.sku,
                    sale_price:     lineItem.sale_price ?? cartData.cart_item.sale_price
                        ?? cartData.cart_item.price_ex_tax
                        ?? cartData.product_value ?? 0,
                    base_price:     lineItem.base_price ?? null,
                    retail_price:   lineItem.retail_price ?? null,
                    purchase_price: lineItem.purchase_price ?? null,
                    quantity:       lineItem.quantity ?? cartData.cart_item.quantity ?? 1,
                    discount:       lineItem.discount ?? 0,
                    brand_name:     lineItem.brand_name || '',
                    category_names: lineItem.category_names || [],
                    variant_id:     lineItem.variant_id ?? null,
                    currency:       lineItem.currency || cartData.currency || 'USD',
                    price:          lineItem.purchase_price ?? 0,
                };
                this.hooks.trackAddToCart?.(enrichedCartItem, enrichedCartItem.currency);

                // getCartPageOvrPricing is now called within updateCartContent after proper sequencing
                this.updateCartContent(this.previewModal, response.data.cart_item.id);
                document.prevFocus = (document.activeElement || document.body);
                openSlideCart();
            });
        }
    }

    /**
     * Get cart contents
     *
     * @param {String} cartItemId
     * @param {Function} onComplete
     */
    getCartContent(cartItemId, onComplete) {
        const options = {
            template: 'cart/preview',
            params: {
                suggest: cartItemId,
            },
            config: {
                cart: {
                    suggestions: {
                        limit: 4,
                    },
                },
            },
        };

        utils.api.cart.getContent(options, onComplete);
    }

    /**
     * Redirect to url
     *
     * @param {String} url
     */
    redirectTo(url) {
        if (this.isRunningInIframe() && !window.iframeSdk) {
            window.top.location = url;
        } else {
            window.location = url;
        }
    }

    /**
     * Update cart content
     *
     * @param {Modal} modal
     * @param {String} cartItemId
     * @param {Function} onComplete
     */
    updateCartContent(modal, cartItemId, onComplete) {
        const $sideCart = $('.side-cart-content');

        if ($sideCart) {
            const $sideCartDetails = $('.side-cart-details');
            const $sideCartActions = $('.side-cart-actions');

            const options = {
                template: {
                    content: 'f/b2b/side-cart-content',
                    details: 'f/b2b/side-cart-details',
                    actions: 'f/b2b/side-cart-actions',
                    counter: 'f/cart/item-count',
                },
            };

            // Step 1: Get updated content and update UI
            utils.api.cart.getContent(options, (err, response) => {
                if (err) {
                    console.error("Error retrieving cart content in updateCartContent: ", err);
                    return;
                }

                if (response == null) {
                    return;
                }

                $sideCart.html(response.content);
                $sideCartDetails.html(response.details);
                $sideCartActions.html(response.actions);

                $('body').trigger('cart-quantity-update', response.counter); // legacy
                bus.emit(Events.CART_UPDATED, { quantity: response.counter });

                // Step 2: NOW get cart data and update pricing (after UI is ready)
                utils.api.cart.getCart({}, (err, cartResponse) => {
                    const sendURL = onlineServiceUrl ?? 'https://api.storesupply.com/';
                    const tru = true;

                    if (err) {
                        console.error("Error retrieving cart data in updateCartContent: ", err);
                        return;
                    }

                    const physicalItems = cartResponse?.lineItems?.physicalItems ?? null;
                    this.hooks.cartOvrPricing?.(physicalItems, sendURL, tru);
                });
            });
        }

        this.getCartContent(cartItemId, (err, response) => {
            if (err) {
                return;
            }

            modal.updateContent(response);
            if (this.context.addToCartMode === 'dropdown') {
                this.showCartPreview();
            }

            // Update cart counter
            const $body = $('body');
            const $cartQuantity = $('[data-cart-quantity]', modal.$content);
            const $cartCounter = $('.navUser-action .cart-count');
            const quantity = $cartQuantity.data('cartQuantity') || 0;

            $cartCounter.addClass('cart-count--positive');
            $body.trigger('cart-quantity-update', quantity); // legacy
            bus.emit(Events.CART_UPDATED, { quantity });

            if (onComplete) {
                onComplete(response);
            }
        });
    }

    showCartPreview() {
        const loadingClass = 'is-loading';
        const $cartDropdown = $('#cart-preview-dropdown');
        const $cartLoading = $('<div class="loadingOverlay"></div>');
        const options = {
            template: 'common/cart-preview',
        };

        function hideCartPreview() {
            $cartDropdown
                .removeClass('cartPreview-isOpen is-open')
                .removeAttr('style')
                .css({
                    left: '-99999px',
                });
        }

        // Redirect to full cart page
        //
        // https://developer.mozilla.org/en-US/docs/Browser_detection_using_the_user_agent
        // In summary, we recommend looking for the string 'Mobi' anywhere in the User Agent to detect a mobile device.
        if (/Mobi/i.test(navigator.userAgent)) {
            return event.stopPropagation(); // eslint-disable-line
        }

        // event.preventDefault();

        $cartDropdown
            .addClass(loadingClass)
            .html($cartLoading);
        $cartLoading
            .show();

        utils.api.cart.getContent(options, (err, response) => {
            $cartDropdown
                .removeClass(loadingClass)
                .html(response);
            $cartLoading
                .hide();
            $cartDropdown
                .addClass('cartPreview-isOpen is-open')
                .css({
                    left: 'inherit',
                    right: '20px',
                    top: '49px',
                })
                .slideDown('fast');
            setTimeout(hideCartPreview, 3000);
        });
    }



    /**
     * Show an message box if a message is passed
     * Hide the box if the message is empty
     * @param  {String} message
     */
    showMessageBox(message, delay) {
        //console.log("triggered", message);
        const $messageBox = $('.productAttributes-message');

        if (message) {
            $('.alertBox-message', $messageBox).text(message);
            $messageBox.show();
            if (delay) {
                clearTimeout(this.messageBoxTimer);
                this.messageBoxTimer = setTimeout(() => {
                    $messageBox.hide();
                }, delay);
            }
        } else {
            $messageBox.hide();
        }
    }

    /**
     * Hide the pricing elements that will show up only when the price exists in API
     * @param viewModel
     */
    clearPricingNotFound(viewModel) {
        viewModel.rrpWithTax.$div.hide();
        viewModel.rrpWithoutTax.$div.hide();
        viewModel.nonSaleWithTax.$div.hide();
        viewModel.nonSaleWithoutTax.$div.hide();
        viewModel.priceSaved.$div.hide();
        viewModel.priceNowLabel.$span.hide();
        viewModel.priceLabel.$span.hide();
    }

    /**
     * Update the view of price, messages, SKU and stock options when a product option changes
     * @param  {Object} data Product attribute data
     */
    updatePriceView(viewModel, price) {
        this.clearPricingNotFound(viewModel);

        if (price.with_tax) {
            viewModel.priceLabel.$span.show();
            viewModel.$priceWithTax.html(price.with_tax.formatted);
        }

        if (price.without_tax) {
            viewModel.priceLabel.$span.show();
            viewModel.$priceWithoutTax.html(price.without_tax.formatted);
        }

        if (price.rrp_with_tax) {
            viewModel.rrpWithTax.$div.show();
            viewModel.rrpWithTax.$span.html(price.rrp_with_tax.formatted);
        }

        if (price.rrp_without_tax) {
            viewModel.rrpWithoutTax.$div.show();
            viewModel.rrpWithoutTax.$span.html(price.rrp_without_tax.formatted);
        }

        if (price.saved) {
            viewModel.priceSaved.$div.show();
            viewModel.priceSaved.$span.html(price.saved.formatted);
        }

        if (price.non_sale_price_with_tax) {
            viewModel.priceLabel.$span.hide();
            viewModel.nonSaleWithTax.$div.show();
            viewModel.priceNowLabel.$span.show();
            viewModel.nonSaleWithTax.$span.html(price.non_sale_price_with_tax.formatted);
        }

        if (price.non_sale_price_without_tax) {
            viewModel.priceLabel.$span.hide();
            viewModel.nonSaleWithoutTax.$div.show();
            viewModel.priceNowLabel.$span.show();
            viewModel.nonSaleWithoutTax.$span.html(price.non_sale_price_without_tax.formatted);
        }
    }

    /**
     * Update the view of wholesale price when a product option changes
     * @param  {Number} variantId Product variant ID
     */
    updateWholesalePriceView(variantId) {
        const w = document.getElementById("single_product_wholesale_price");
        if (w && wholesalePriceMap[variantId]) {
            const s = w.querySelector("span.price");
            s.innerText = USD.format(wholesalePriceMap[variantId]);
        }
    }

    /**
     * Update the view of subscription price when a product option changes
     * @param  {Object} price Product attribute data
     */
    updateSubscriptionPricing(price) {
        const s = document.getElementById("subscription_discounted_price");
        if (s && rcaSubscribeDiscount) {
            s.innerText = (rcaSubscribeRadio.checked ? price.without_tax.formatted : USD.format(price.without_tax.value * (1 - rcaSubscribeDiscount)));
        }
    }

    /**
     * Update the view of price, messages, SKU and stock options when a product option changes
     * @param  {Object} data Product attribute data
     */
    updateView(data, content = null) {
        if (!data || typeof data !== 'object') {
            console.warn('Invalid data passed to updateView');
            return;
        }
        console.debug("UpdateView", data);

        if (!data || Object.keys(data).length === 0) {
            console.warn('Invalid data passed to updateView');
            return;
        }

        const viewModel = this.getViewModel(this.$scope);
        //data.stock_message = "hee";
        //document.querySelector("#productView-images-container > div > figure > div > a > img")?.setAttribute('data-sku', data.sku || '');

        //$main.slick('unslick');
        //$nav.slick('unslick');
        //productGallery();

        this.hooks.variantDetailsChange?.(data.sku, this.context.themeSettings.shopper_approved_siteId, data?.price?.without_tax.value, this.context.productSku.id, this.context.onlineServicesHost, this.context.themeSettings.appId, null, this.context.productSku.custom_fields, this.context.themeSettings.shopper_approved_review_widgetId,this.context.gqlProduct?.metafields?.edges,null,this.context.themeSettings.subscription_modifier_label_discount);
        this.hooks.configuratorPriceUpdate?.(data.sku, this.context.authorization, data?.image?.data,this.context.gqlProduct?.metafields?.edges);

        //(data.sku,this.context.authorization);
        //if(window.location.pathname.startsWith('/custom')){
        //createSubscriptionWidget('add-to-cart-wrapper-custom', 'attribute_select_1558');
        //}
        this.showMessageBox(data.stock_message || data.purchasing_message);

        if (isObject(data.price)) {
            this.updatePriceView(viewModel, data.price);
            this.updateSubscriptionPricing(data.price);
        }

        if (isObject(data.weight)) {
            viewModel.$weight.html(data.weight.formatted);
        }

        // Set variation_id if it exists for adding to wishlist
        if (data.variantId) {
            viewModel.$wishlistVariation.val(data.variantId);
            this.updateWholesalePriceView(data.v3_variant_id);
        }

        // Favorites star: V3 variant id (GraphQL variantEntityId). Emitted on every
        // option change, including back to "no variant selected" (null).
        bus.emit(Events.PRODUCT_VARIANT_CHANGED, {
            variantId: data.v3_variant_id == null ? null : Number(data.v3_variant_id),
            sku: data.sku || null,
        });

        // If SKU is available
        if (data.sku) {
            viewModel.sku.$value.text(data.sku);
            viewModel.sku.$label.show();
        } else {
            viewModel.sku.$label.hide();
            viewModel.sku.$value.text('');
        }

        // If UPC is available
        if (data.upc) {
            viewModel.upc.$value.text(data.upc);
            viewModel.upc.$label.show();
        } else {
            viewModel.upc.$label.hide();
            viewModel.upc.$value.text('');
        }

        // if stock view is on (CP settings)
        if (viewModel.stock.$container.length && isNumber(data.stock)) {
            // if the stock container is hidden, show
            viewModel.stock.$container.removeClass('u-hiddenVisually');

            viewModel.stock.$input.text(data.stock);
        } else {
            viewModel.stock.$container.addClass('u-hiddenVisually');
            viewModel.stock.$input.text(data.stock);
        }

        mergeBackorderData(this.backorder, data);
        this.updateDefaultAttributesForOOS(data);
        // After the OOS pass: applySellLimit reads the increments' disabled state.
        this.refreshBackorderView();

        // If Bulk Pricing rendered HTML is available
        if (data.bulk_discount_rates && content) {
            viewModel.$bulkPricing.html(content);
        } else if (typeof (data.bulk_discount_rates) !== 'undefined') {
            viewModel.$bulkPricing.html('');
        }

        const addToCartWrapper = $('#add-to-cart-wrapper');

        if (addToCartWrapper.is(':hidden') && data.purchasable) {
            addToCartWrapper.show();
        }
    }

    updateDefaultAttributesForOOS(data) {
        if (!data || typeof data !== 'object') {
            console.warn('Invalid data passed to updateDefaultAttributesForOOS');
            return;
        }


        //console.debug("OOS Update", data);
        if (data && Object.keys(data).length > 0) {
            // data is not null and not an empty object
            const viewModel = this.getViewModel(this.$scope);

            if (!data.purchasable || !canSell(this.backorder, data)) {
                viewModel.$addToCart.prop('disabled', true);
                viewModel.$increments.prop('disabled', true);
                viewModel.stock.$container.removeClass('form-label--stock').addClass('form-label--out-of-stock');

                const element = document.querySelector('.card-stock.card-stock--inStock');
                if (element) element.style.display = 'none';
            } else {
                viewModel.$addToCart.prop('disabled', false);
                viewModel.$increments.prop('disabled', false);
                viewModel.stock.$container.removeClass('form-label--out-of-stock').addClass('form-label--stock');

                const element = document.querySelector('.card-stock.card-stock--inStock');
                if (element) element.style.display = 'block';
            }
        }
    }

    /**
     * Redraw the backorder prompt / "N will be backordered" row and apply the
     * available_to_sell cap for the current (or given) quantity. Pure logic lives
     * in utils/backorder-utils.js; this method only writes the DOM.
     * @param {Number} [qty] requested quantity; defaults to the quantity input value
     */
    refreshBackorderView(qty) {
        const $prompt = $('[data-backorder-prompt]', this.$scope);
        const $row = $('[data-product-backordered]', this.$scope);
        if (!$prompt.length && !$row.length) return; // no backorder markup on this page (quick view)

        const ctx = this.backorder;
        const viewModel = this.getViewModel(this.$scope);
        const requested = qty !== undefined ? qty : (parseInt(viewModel.quantity.$input.val(), 10) || 0);

        if (showAvailabilityPrompt(ctx)) {
            $prompt.text(ctx.promptText).show();
        } else {
            $prompt.hide();
        }

        const backordered = backorderedQty(ctx, requested);
        const qtyText = ctx.showQtyOnBackorder && backordered > 0
            ? ctx.qtyMessage.replace('__QTY__', backordered)
            : '';
        const messageText = resolveBackorderMessage(ctx, backordered);
        $('[data-qty-backordered-message]', $row).text(qtyText);
        $('[data-backorder-message]', $row).text(messageText);
        $row.toggle(Boolean(qtyText || messageText));

        this.applySellLimit(requested, viewModel);
    }

    /**
     * Disable Add to Cart with the max-quantity message when the requested qty
     * exceeds available_to_sell; clear only a message this method set, and never
     * re-enable a button the out-of-stock path disabled.
     */
    applySellLimit(requested, viewModel) {
        const $box = $('#add-to-cart-wrapper .productAttributes-message', this.$scope);
        const limit = sellLimitExceeded(this.backorder, requested);

        if (limit !== null) {
            viewModel.$addToCart.prop('disabled', true);
            $('.alertBox-message', $box).text(this.backorder.maxMessage.replace('__QTY__', limit));
            $box.attr('data-qty-limit', 'true').show();
            return;
        }

        if ($box.attr('data-qty-limit') === 'true') {
            $box.removeAttr('data-qty-limit').hide();
            $('.alertBox-message', $box).text('');
            if (!viewModel.$increments.prop('disabled')) {
                viewModel.$addToCart.prop('disabled', false);
            }
        }
    }

    /**
     * Hide or mark as unavailable out of stock attributes if enabled
     * @param  {Object} data Product attribute data
     */
    updateProductAttributes(data) {
        const behavior = data.out_of_stock_behavior;
        // BC's optionChange response can return in_stock_attributes: null (SSW-QA-033)
        const inStockIds = data.in_stock_attributes || [];
        const outOfStockMessage = ` (${data.out_of_stock_message})`;
        //console.log("Updated Attributes: " + outOfStockMessage);
        //const outOfStockMessage = "Item Will Return By 12/12/2024";

        this.showProductImage(data.image);
        this.hooks.optionImageGallery?.(data, this.$scope, this.$slick);

        if (behavior !== 'hide_option' && behavior !== 'label_option') {
            return;
        }

        $('[data-product-attribute-value]', this.$scope).each((i, attribute) => {
            const $attribute = $(attribute);
            const attrId = parseInt($attribute.data('productAttributeValue'), 10);


            if (inStockIds.indexOf(attrId) !== -1) {
                this.enableAttribute($attribute, behavior, outOfStockMessage);
            } else {
                this.disableAttribute($attribute, behavior, outOfStockMessage);
            }
        });
    }

    disableAttribute($attribute, behavior, outOfStockMessage) {
        if (this.getAttributeType($attribute) === 'set-select') {
            return this.disableSelectOptionAttribute($attribute, behavior, outOfStockMessage);
        }

        if (behavior === 'hide_option') {
            $attribute.hide();
        } else {
            $attribute.addClass('unavailable');
        }
    }

    disableSelectOptionAttribute($attribute, behavior, outOfStockMessage) {
        const $select = $attribute.parent();

        if (behavior === 'hide_option') {
            $attribute.toggleOption(false);
            // If the attribute is the selected option in a select dropdown, select the first option (MERC-639)
            if ($select.val() === $attribute.attr('value')) {
                $select[0].selectedIndex = 0;
            }
        } else {
            $attribute.attr('disabled', 'disabled');
            $attribute.html($attribute.html().replace(outOfStockMessage, '') + outOfStockMessage);
        }
    }

    enableAttribute($attribute, behavior, outOfStockMessage) {
        if (this.getAttributeType($attribute) === 'set-select') {
            return this.enableSelectOptionAttribute($attribute, behavior, outOfStockMessage);
        }

        if (behavior === 'hide_option') {
            $attribute.show();
        } else {
            $attribute.removeClass('unavailable');
        }
    }

    enableSelectOptionAttribute($attribute, behavior, outOfStockMessage) {
        if (behavior === 'hide_option') {
            $attribute.toggleOption(true);
        } else {
            $attribute.prop('disabled', false);
            $attribute.html($attribute.html().replace(outOfStockMessage, ''));
        }
    }

    getAttributeType($attribute) {
        const $parent = $attribute.closest('[data-product-attribute]');

        return $parent ? $parent.data('productAttribute') : null;
    }

    /**
     * Allow radio buttons to get deselected
     */
    initRadioAttributes() {
        $('[data-product-attribute] input[type="radio"]', this.$scope).each((i, radio) => {
            const $radio = $(radio);

            // Only bind to click once
            if ($radio.attr('data-state') !== undefined) {
                $radio.on('click', () => {
                    if ($radio.data('state') === true) {
                        $radio.prop('checked', false);
                        $radio.data('state', false);

                        $radio.trigger('change');
                    } else {
                        $radio.data('state', true);
                    }

                    this.initRadioAttributes();
                });
            }

            $radio.attr('data-state', $radio.prop('checked'));
        });
    }

    /**
     * Check for fragment identifier in URL requesting a specific tab
     */
    getTabRequests() {
        if (window.location.hash && window.location.hash.indexOf('#tab-') === 0) {
            const $activeTab = $('.tabs').has(`[href='${window.location.hash}']`);
            const $tabContent = $(`${window.location.hash}`);

            if ($activeTab.length > 0) {
                $activeTab.find('.tab')
                    .removeClass('is-active')
                    .has(`[href='${window.location.hash}']`)
                    .addClass('is-active');

                $tabContent.addClass('is-active')
                    .siblings()
                    .removeClass('is-active');
            }
        }
    }

    getLiveInventoryInfo(sku, rcallback) {
        fetchLiveInventory(this.context.onlineServicesHost, sku, this.context.themeSettings?.appId).then((inventoryInfo) => {
            if (!inventoryInfo) return;
            // Backorder row: a usable nextAvailableDate replaces the store default message.
            mergeLiveInventory(this.backorder, inventoryInfo);
            this.refreshBackorderView();
            rcallback(inventoryInfo);
        });
    }
    buildVariantOptionSelectors(product) {
        // Navigate to the options within the first variant node
        const options = product.variants?.edges[0]?.node?.options?.edges;

        if (!options || options.length === 0) {
            return null; // No options to build
        }

        const optionsContainer = document.createElement('div');
        // Add a wrapper div similar to the example for styling consistency
        optionsContainer.id = `data-product-option-change-${product.entityId}`;
        optionsContainer.setAttribute('data-product-option-change', '');
        optionsContainer.style.display = 'none';
        options.forEach(({ node: option }) => {
            const optionWrapper = document.createElement('div');
            optionWrapper.classList.add('form-field');
            // We assume 'radio' as we cannot determine if it's a 'swatch' from the query
            optionWrapper.setAttribute('data-product-attribute', 'radio');

            const mainLabel = document.createElement('label');
            mainLabel.classList.add('form-label', 'form-label--alternate', 'form-label--inlineSmall');

            // As we don't know the default, we'll pick the first one's label to display initially.
            const initialLabelText = option.values.edges[0]?.node.label || '';

            mainLabel.innerHTML = `
            ${option.displayName}:
            <span data-option-value="">${initialLabelText}</span>
            <small class="required-label">Required</small>
        `;
            optionWrapper.appendChild(mainLabel);

            // Create the radio inputs for each value
            option.values.edges.forEach(({ node: value }, index) => {
                const optionId = option.entityId;
                const valueId = value.entityId;
                // Use a unique prefix for the ID to avoid conflicts on the page
                const inputId = `acc_attribute_radio_${optionId}_${valueId}`;

                const input = document.createElement('input');
                input.classList.add('form-radio');
                input.type = 'radio';
                input.name = `attribute[${optionId}]`;
                input.id = inputId;
                input.value = valueId;
                input.required = true; // Assume required to prevent cart errors

                // Set the first option as checked by default
                if (index === 0) {
                    input.checked = true;
                }

                // This label is for the radio button itself
                const valueLabel = document.createElement('label');
                valueLabel.classList.add('form-option');
                valueLabel.setAttribute('for', inputId);
                valueLabel.setAttribute('data-product-attribute-value', valueId);

                // We create a simple text-based label since we don't have swatch images.
                valueLabel.innerHTML = `<span class="form-option-variant">${value.label}</span>`;

                optionWrapper.appendChild(input);
                optionWrapper.appendChild(valueLabel);

                // Add event listener to update the main label text on change
                input.addEventListener('change', (event) => {
                    if (event.target.checked) {
                        const topLabelSpan = event.target.closest('.form-field').querySelector('[data-option-value]');
                        if (topLabelSpan) {
                            topLabelSpan.textContent = value.label;
                        }
                    }
                });
            });

            optionsContainer.appendChild(optionWrapper);
        });

        return optionsContainer;
    }
    recommendedAccessories() {
        // Use unified recommended accessories module
        // Get layout orientation from theme settings
        const orientation = this.context?.themeSettings?.['recommended-accessories-display-direction'] || 'vertical';

        function isValidJson(str) {
            if (typeof str !== 'string') return false;
            try { JSON.parse(str); return true; } catch { return false; }
        }

        // Get data-ids as fallback
        let metaData;
        const edges = this.context?.gqlProduct?.metafields?.edges;
        //const selectedSku = variantPricingItems?.data?.site?.product?.sku;
        if (Array.isArray(edges) && edges.length > 0) {
            for (const edge of edges) {
                const key = edge?.node?.key;
                const value = edge?.node?.value;

                if (key === "Details" && value && isValidJson(value)) {

                try {
                    const parsed = JSON.parse(value);
                    const product = parsed?.skuSpecificData?.[this.context?.productSku?.sku];
                    metaData = product.accessories;
                } catch (e) {

                }

                }

            }
        } else {
            console.debug('[recommendedAccessories] No metafield edges available:', edges);
        }



        const acc = document.getElementById('recommended_accessories');
        const dataIds = acc?.getAttribute('data-ids') || null;
        let items;
        if (Array.isArray(metaData)) {
        items = metaData.slice();
        } else if (typeof metaData === 'string') {
        items = metaData.split(',');
        } else if (metaData && typeof metaData[Symbol.iterator] === 'function') {
        // Handles Set or any iterable
        items = Array.from(metaData);
        } else {
        items = [];
        }

        items = items.map(s => String(s).trim()).filter(Boolean);
        const uniq = Array.from(new Set(items));        // de‑dupe but keep as ARRAY
        const sig  = uniq.join('|');
        // Call unified renderer with fallback data-ids
        // Note: Metafield accessories are handled by custom-products.js via debouncedConfiguratorVariantPriceUpdate
        // This only triggers if metafields don't provide data
        this.hooks.renderAccessories?.({
            accessories: uniq, // Will be populated by custom-products.js if metafields exist
            dataIds: dataIds,
            token: this.context.authorization,
            orientation: orientation,
            context: this.context
        })?.then(result => {
            if (result.ok) {
                console.log(`[ProductDetails] Recommended accessories: ${result.reason}`, result);
            } else {
                console.warn(`[ProductDetails] Recommended accessories failed: ${result.reason}`, result);
            }
        })?.catch(err => {
            console.error('[ProductDetails] Recommended accessories error:', err);
        });
    }
//     /**
//  * Hide/show <li> items inside #product-details-image-carousel by matching img[data-sku].
//  * Shows items where data-sku === provided sku; hides all others.
//  * If an <li> has no img[data-sku], it is hidden.
//  * @param {string|number} sku
//  */
// filterCarouselBySku(sku) {
//   const expected = String(sku).trim();
//   const items = document.querySelectorAll('#product-details-image-carousel > div > div > li');

//   items.forEach(li => {
//     const img = li.querySelector('img[data-sku]');
//     const actual = img ? String(img.getAttribute('data-sku') || '').trim() : '';
//     const isMatch = actual === expected;

//     li.classList.toggle('is-hidden-product', !isMatch);
//     li.setAttribute('aria-hidden', String(!isMatch));
//   });
// }

// /** Show all items again (undo filtering). */
// showAllCarouselItems() {
//   const items = document.querySelectorAll('#product-details-image-carousel > li');
//   items.forEach(li => {
//     li.classList.remove('is-hidden-product');
//     li.setAttribute('aria-hidden', 'false');
//   });
// }
}
